import { render } from "./SidebarCards.vue?vue&type=template&id=37abf1b5&scoped=true"
import script from "./SidebarCards.vue?vue&type=script&lang=js"
export * from "./SidebarCards.vue?vue&type=script&lang=js"

import "./SidebarCards.vue?vue&type=style&index=0&id=37abf1b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37abf1b5"]])

export default __exports__